import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    output,
  } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { BoardCard } from '@fry/boards/lib';

@Component({
    selector: 'eas-board-layout-editor-card',
    templateUrl: './board-layout-editor-card.component.html',
    //styleUrls: ['./board-layout-editor-card.component.css'],
    imports: [
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        RouterModule,
    ],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardLayoutEditorCardComponent implements OnInit, OnDestroy {

  @Input() public card!: BoardCard;
  public deleteCard = output<string>();
  public editCard = output<string>();

  constructor() {
  }

  ngOnInit() {
    console.warn('DashboardLayoutEditorCardComponent.ngOnInit', this.card);
  }

  ngOnDestroy(): void {
  }

  //
  // Actions
  //

  public onDelete(): void {
    this.deleteCard.emit(this.card.id);
  }

  public onEdit(): void {
    this.editCard.emit(this.card.id);
  }
}
